import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { UtilsService } from 'src/app/services/utils/utils.service';
import { LatLng } from '@ionic-native/google-maps';
import { RestService } from 'src/app/services/rest/rest.service';
import { ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';

declare var google;

@Component({
  selector: 'app-map-details',
  templateUrl: './map-details.page.html',
  styleUrls: ['./map-details.page.scss'],
})
export class MapDetailsPage implements OnInit {

  @ViewChild('map', { static: false }) mapElement: ElementRef;
  map: any;
  id: any;
  coordinates: any[] = [];
  albaranCoordinates: any[] = [];

  constructor(private utils: UtilsService,
    private route: ActivatedRoute,
    private location: Location,
    private rest: RestService) {
    this.id = this.route.snapshot.paramMap.get('id');
  }

  async ngOnInit() {
    await this.loadMapWithCoordinates();
  }

  goBack() {
    this.location.back();
  }

  async loadMapWithCoordinates() {
    try {

      // await this.utils.showLoading();
      const resp: any = await this.rest.getLocationsBySessionId(this.id);
      console.log(resp);
      if (resp) {
        this.coordinates = resp.body.location.coordinates || [];
        this.coordinates = this.coordinates.sort((a, b) => a.date - b.date);
        this.albaranCoordinates = resp.body.albaranes || [];
      }
      let center: LatLng;
      if (!this.coordinates || this.coordinates.length === 0) {
        center = new google.maps.LatLng(40.416664, -3.703989);
      } else {
        center = new google.maps.LatLng(this.coordinates[0].latitude, this.coordinates[0].longitude);
      }

      const mapOptions = {
        center,
        zoom: 11,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        disableDefaultUI: true,
        styles: [{ featureType: 'poi', elementType: 'labels', stylers: [{ visibility: 'off' }] }]
      };
      // We create the map
      this.map = new google.maps.Map(this.mapElement.nativeElement, mapOptions);


      // // TODO: No detecta este evento
      // this.map.on(GoogleMapsEvent.MAP_CLICK).subscribe((point) => {
      //   this.map.setZoom(11);
      //   this.map.setCenter(point.latLng);
      //   // this.map.setCenter(.getPosition());
      // });

      // This event listener calls addMarker() when the map is clicked.
      google.maps.event.addListener(this.map, 'click', (event) => {
        this.map.setCenter(event.latLng);
      });

      const trip = new google.maps.Polyline({
        path: this.coordinates.map(coords => {
          return {
            lat: parseFloat(coords.latitude),
            lng: parseFloat(coords.longitude)
          }
        }),
        strokeColor: '#FF0000',
        icons: [{
          icon: { path: google.maps.SymbolPath.FORWARD_CLOSED_ARROW },
          offset: '100%',
          repeat: '500px'
        }],
        strokeWeight: 3.5
      });
      trip.setMap(this.map);
      this.coordinates.forEach(
        (coords, index) => {
          if (coords.latitude && coords.longitude && index % 5 === 0) {
            const time = new Date(coords.date).toLocaleTimeString('es-ES').slice(0, -3);
            coords.date = new Date(coords.date).toLocaleDateString('es-ES');
            coords.date = coords.date + ' - ' + time;
            const marker = new google.maps.Marker({
              map: this.map,
              // label: (index + 1).toString(),
              position: {
                lat: parseFloat(coords.latitude),
                lng: parseFloat(coords.longitude)
              },
              icon: {
                // url: '../../../assets/images/dot-marker.png',
                url: 'http://maps.google.com/mapfiles/kml/pal4/icon49.png',
                size: {
                  width: 25,
                  height: 25
                }
              },
            });
            const infowindow = new google.maps.InfoWindow({
              content: `<p>${coords.date}</p>`
            });

            google.maps.event.addListener(marker, 'click', () => {
              this.map.panTo(marker.getPosition());
              infowindow.open(this.map, marker);
            });

          }
        }
      );

      this.albaranCoordinates.forEach(coordsMain => {
        if (!Array.isArray(coordsMain)) {
          coordsMain = [coordsMain];
        }
        coordsMain.forEach(async coords => {

          const client: any = await this.rest.getClient(coords.cliente);
          if (coords.location.latitude && coords.location.longitude) {
            const time = new Date(coords.fecha).toLocaleTimeString('es-ES').slice(0, -3);
            coords.fecha = new Date(coords.fecha).toLocaleDateString('es-ES');
            coords.fecha = coords.fecha + ' - ' + time;
            const marker = new google.maps.Marker({
              map: this.map,
              position: {
                lat: parseFloat(coords.location.latitude),
                lng: parseFloat(coords.location.longitude)
              },
              // icon: {
              //   url: 'http://maps.google.com/mapfiles/kml/pal4/icon49.png',
              //   size: {
              //     width: 40,
              //     height: 40
              //   }
              // },
              style: [
                {
                  featureType: 'poi',
                  stylers: [
                    {
                      visibility: 'off'
                    }
                  ]
                }
              ]
            });
            const infowindow = new google.maps.InfoWindow({
              content: `<p>Cliente: ${client.body.nombre}<br>Albaran: ${coords.id}<br>Fecha: ${coords.fecha}</p>`
            });
            google.maps.event.addListener(marker, 'click', () => {
              this.map.panTo(marker.getPosition());
              infowindow.open(this.map, marker);
            });
          }
        });
      });
      // await this.utils.hideLoading();
    } catch (error) {
      console.log(error);
      await this.utils.showToast('Error al cargar posiciones del repartidor', 'danger', 3000);
    }
  }

}
